



















































































































import { Vue, Component } from 'vue-property-decorator'
import store from 'src/assets/store'
import ButtonPublish from 'components/presenter/layout/MenuButtonPublish.vue'
import ButtonCopy from 'components/presenter/layout/MenuButtonCopy.vue'
import ButtonMove from 'components/presenter/layout/MenuButtonMove.vue'
import ButtonDelete from 'components/presenter/layout/MenuButtonDelete.vue'
import { ItemType, ItemTypeTopic } from 'src/graphql/types'

@Component({
  components: {
    ButtonPublish,
    ButtonCopy,
    ButtonMove,
    ButtonDelete
  }
})
export default class PresenterLayoutItem extends Vue {
  ItemType = ItemType
  ItemTypeTopic = ItemTypeTopic
  state = store.state

  get item () {
    return store.state.presenter.item
  }

  get light () {
    return this.$q.screen.lt.md
  }
}

